import React from 'react';
import { querySelector } from 'kagekiri';
import { IressCheckbox, IressRadio, IressTabButton, IressTabPanel, IressMenuItem, LoggerLevels, } from '../wrappers';
import { idsLogger } from './helpers';
export const mapCheckboxGroupOptions = (options) => {
    if (!options || !options.length)
        return null;
    return options.map(({ label, value, testId }, key) => (React.createElement(IressCheckbox, { value: value, key: key, "data-testid": testId ? testId : null }, label)));
};
export const mapRadioGroupOptions = (options) => {
    if (!options || !options.length)
        return null;
    return options.map(({ label, value, testId }, key) => (React.createElement(IressRadio, { value: value, key: key, "data-testid": testId ? testId : null }, label)));
};
export const mapSelectOptions = (options) => {
    if (!options || !options.length)
        return null;
    return options.map(({ label, value, testId }, key) => (React.createElement("option", { value: value, key: key, "data-testid": testId ? testId : null }, label)));
};
export const mapTabs = (tabs) => {
    if (!tabs || !tabs.length)
        return null;
    const tabButtons = tabs.map(({ tabName, active, tabButtonText, tabButtonTestId, tabButtonOnClick, }, key) => (React.createElement(IressTabButton, { tabName: tabName, active: active, key: key, "data-testid": tabButtonTestId ? `${tabButtonTestId}` : null, slot: "tab-list", onClick: tabButtonOnClick }, tabButtonText)));
    const tabPanels = tabs.map(({ tabName, active, tabPanelContent, tabPanelTestId }, key) => (React.createElement(IressTabPanel, { tabName: tabName, active: active, key: key, "data-testid": tabPanelTestId ? `${tabPanelTestId}` : null }, tabPanelContent)));
    return (React.createElement(React.Fragment, null,
        tabButtons,
        tabPanels));
};
export const mapMenuItems = (items) => {
    if (!items || !items.length)
        return null;
    return items.map(({ label, href, onClick, divider, testId, headingLevel, selected, value, }, key) => (React.createElement(IressMenuItem, { key: key, href: href, onClick: onClick, divider: divider, headingLevel: headingLevel, selected: selected, "data-testid": testId ? `${testId}` : null, value: value }, label)));
};
const getOverlayPanel = (overlayEl) => {
    if (typeof overlayEl === 'string')
        return querySelector(`#${overlayEl}`);
    return overlayEl;
};
export const showComponent = (overlayEl, open = true) => {
    const overlay = getOverlayPanel(overlayEl);
    if (!overlay)
        return;
    if (!open) {
        if (overlay.getAttribute('show') === '') {
            overlay.removeAttribute('show');
        }
    }
    else {
        overlay.setAttribute('show', '');
    }
};
export const showModal = (modalId, open = true) => showComponent(modalId, open);
export const showSlideout = (slideoutId, open = true) => showComponent(slideoutId, open);
export const rowData = (arr, ref) => {
    idsLogger('IressTable: Use of the method rowData is now deprecated, please apply object directly to the rowData property on IressTable', LoggerLevels.Warn);
    setObjProperty('rowData', arr, ref);
};
export const setObjProperty = (property, obj, ref) => {
    if (ref.current)
        ref.current[property] = obj;
};
//# sourceMappingURL=render.helpers.js.map